
import state from './approvalState.js'
import mutations from './approvalMutations.js'
import actions from './approvalAction.js'
import getters from './approvalGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

